import { Snackbar as MuiSnackbar, SnackbarProps as MuiSnackbarProps } from '@material-ui/core';
import { Alert, AlertProps } from '@material-ui/lab';
import React from 'react';

interface SnackbarProps {
  children?: React.ReactNode;
  anchorOrigin?: MuiSnackbarProps['anchorOrigin'];
  severity?: AlertProps['severity'];
  autoHideDuration?: MuiSnackbarProps['autoHideDuration'];
  [key: string]: any; // Allow other props to be passed
}

const Snackbar = ({
  children,
  anchorOrigin = { vertical: 'top', horizontal: 'center' },
  severity,
  autoHideDuration = 4000, // Default auto-hide duration
  ...props
}: SnackbarProps) => (
  <MuiSnackbar anchorOrigin={anchorOrigin} open={Boolean(children)} autoHideDuration={autoHideDuration} {...props}>
    <Alert variant="filled" severity={severity}>
      {children}
    </Alert>
  </MuiSnackbar>
);

export default Snackbar;
